import React, { useEffect, useRef } from "react";
import { utilService } from "../../../../../services";
import { CallService } from "../../Call.service";
import { useCall } from "../../../WebRTCCall/CallProvider";

/**
 * Thin trigger for the peer-to-peer WebRTC call flow.
 *
 * The old implementation used JsSIP against the vendor's Asterisk, which does
 * not exist on this deployment. Calling now runs entirely through CallProvider
 * (browser-to-browser audio, signaling over ws/call/), so this component keeps
 * its original props/interface but simply hands the target off to the provider
 * and closes the caller's own modal. The call UI lives in CallProvider.
 */

interface callUserParams {
  doctorInfoData: any;
  listData?: any;
  isShowCallUserModal: boolean;
  isPrimaryNumber: boolean;
  isAssignedNumber?: boolean;
  capabilityTokenData: string;
  onCancel: () => void;
  onOk: () => void;
  userNetwork?: string;
}

const CallUser: React.FC<callUserParams> = (props) => {
  const { startCall } = useCall();
  const started = useRef(false);
  const loggedInUserGuid = utilService.getLoggedUserGuid();

  useEffect(() => {
    if (!props.isShowCallUserModal) {
      started.current = false;
      return;
    }
    if (started.current) return;
    started.current = true;

    const ud = props.doctorInfoData?.userData || {};
    // Routing is by guid, which the user record always carries.
    const peerGuid = ud.guid;
    const name =
      ud.name ||
      ud.display_name ||
      ud.firstName ||
      `${ud.first_name || ""} ${ud.last_name || ""}`.trim() ||
      "";

    if (peerGuid) {
      startCall(String(peerGuid), name);
      try {
        CallService.createCallHistory({
          to_guid: ud.guid,
          from_guid: loggedInUserGuid,
          to_number: ud.mobile_number_history,
          n2n_network: props?.userNetwork ?? "",
        });
      } catch (e) {
        /* call-history logging is best-effort */
      }
    }

    // Hand control to the global CallProvider UI and close this trigger modal.
    props.onOk();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isShowCallUserModal]);

  return null;
};

export default CallUser;
